export default "__VITE_PUBLIC_ASSET__aadba2b0__"